var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"white",attrs:{"label":"Year","items":_vm.data,"loading":_vm.api.isLoading,"placeholder":"Year","outlined":""},model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}})}
var staticRenderFns = []

export { render, staticRenderFns }